import React from 'react';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';
import {maybe} from '@/util';

const showField = item => {
  const checkVal = R.propOr(true, 'checkVal')(item);
  return maybe(checkVal).map(() => (
    <tr key={item.name}>
      <th>{item.name}</th>
      <td>{item.displayVal}</td>
    </tr>
  ));
};

const FundPlatformOverview = ({plan}) => {
  const {t: tr} = useTranslation('statements');
  const fields = R.map(R.zipObj(['name', 'displayVal', 'checkVal']))([
    [tr('account_holder'), plan.policyOwner],
    [tr('address'), R.join(' ', plan.address)],
    [tr('account_no'), plan.planNo],
    [tr('ac_opening_date'), plan.commenceDate],
    [tr('payment_freq'), plan.paymentFrequency],
    [
      R.join(' / ', [tr('policy_status'), tr('payment_status')]),
      R.join('', [plan.policyStatus, ' / ', plan.paymentStatus]),
    ],
    [tr('portfolio_type'), plan.portfolioType],
    [tr('account_type'), plan.productName],
    [tr('joint_account_holder'), plan.jointOwner, plan.jointOwner],
    [tr('report_currency'), plan.valuationCurrency],
  ]);

  const itemlist = R.map(item => showField(item))(fields);

  return (
    <table className='info'>
      <tbody>{itemlist}</tbody>
    </table>
  );
};

export default FundPlatformOverview;
